import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ccd5e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "TestInstructionsStepSeven" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-info" }, " Estamos quase lá! Insira qual o período de ocorrência do risco de contato com o vírus, para receber a melhor orientação relativa ao seu resultado. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " Há quanto tempo você suspeita do contato com o HIV? ", -1))
const _hoisted_4 = { class: "question-options" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-text" }, "Até 3 dias", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-text" }, "4 dias até 29 dias", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-text" }, "30 dias ou mais", -1))
const _hoisted_8 = { class: "error-info" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Campo de preenchimento obrigatório, selecione uma opção.", -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_floating_card = _resolveComponent("floating-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_floating_card, {
      ref: "base-modal",
      stepNumber: "7",
      stepTitle: "Informar tempo de exposição",
      nextButtonActive: _ctx.canJumpNext,
      btnNextLabel: "Gerar cartão de resultado",
      onNextStep: _cache[3] || (_cache[3] = ($event: any) => (this.$emit('nextStep'))),
      onPreviousStep: _cache[4] || (_cache[4] = ($event: any) => (this.$emit('previousStep')))
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("input", {
              name: "exposureTime",
              type: "radio",
              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setHivContact(_ctx.hivContact.until_three_days)))
            }, null, 32),
            _hoisted_5
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("input", {
              name: "exposureTime",
              type: "radio",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setHivContact(_ctx.hivContact.between_four_and_twenty_nine)))
            }, null, 32),
            _hoisted_6
          ], 2),
          _createElementVNode("label", {
            class: _normalizeClass(["custom-radio", { 'has-error': _ctx.hasError }])
          }, [
            _createElementVNode("input", {
              name: "exposureTime",
              type: "radio",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setHivContact(_ctx.hivContact.thirty_days_or_more)))
            }, null, 32),
            _hoisted_7
          ], 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [
          [_vShow, _ctx.hasError]
        ])
      ]),
      _: 1
    }, 8, ["nextButtonActive"])
  ]))
}